import React, { useState, useEffect, useRef } from "react";
import { getQueryStringValue } from "../../Shared/queryString";
import { PaymentStatusApi } from "../../Shared/Services/PaymentStatusApi";
import { PaymentStatusEnum } from "../../DTO/PaymentStatusEnum";
import PaymentPending from "./PaymentPending";
import PaymentSuccessful from "./PaymentSuccessful";
import PaymentFailed from "./PaymentFailed";

const PaymentStatus: React.FC = () => {
  const [uniqueReference] = useState(
    getQueryStringValue("uniqueReference") || ""
  );
  const [paymentStatus, setPaymentStatus] = useState(PaymentStatusEnum.Pending);
  const isMounted = useRef(true);

  let _paymentStatusApi: PaymentStatusApi = new PaymentStatusApi();

  const getPaymentStatus = async (): Promise<PaymentStatusEnum> => {
    try {

      if (!uniqueReference || uniqueReference.length === 0)
        return PaymentStatusEnum.Pending;

      const getPaymentStatusResponse = await _paymentStatusApi.GetPaymentStatus(
        uniqueReference
      );

      if (
        !getPaymentStatusResponse.success ||
        getPaymentStatusResponse.result === null
      ) {
        return PaymentStatusEnum.Pending;
      }

      return getPaymentStatusResponse.result
        ? getPaymentStatusResponse.result.paymentStatus
        : PaymentStatusEnum.Pending;
    } catch (e) {
      console.log(
        `There was an error while retrieving the payment status.\nPlease try again.\nError: ${e}`
      );

      return PaymentStatusEnum.Pending;
    }
  };

  const queueGetPaymentStatus = () => {
    const timer = setTimeout(async () => {
      clearTimeout(timer);
      if (!isMounted.current) return; // stop if unmounted
      let paymentStatus: PaymentStatusEnum = await getPaymentStatus();
      if (!isMounted.current) return; // check again after async

      if (paymentStatus === PaymentStatusEnum.Pending) {
        queueGetPaymentStatus();
      } else {
        setPaymentStatus(paymentStatus);
      }
    }, 1000);
  };

  useEffect(() => {
    isMounted.current = true;
    queueGetPaymentStatus();
    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <div className="App">
      {paymentStatus === PaymentStatusEnum.Pending && <div data-testid="jest-paymentpending"><PaymentPending /></div>}
      {paymentStatus === PaymentStatusEnum.Processed && <div data-testid="jest-paymentsuccessful"><PaymentSuccessful /></div>}
      {paymentStatus !== PaymentStatusEnum.Pending &&
        paymentStatus !== PaymentStatusEnum.Processed && <div data-testid="jest-paymentfailed"><PaymentFailed /></div>}
    </div>
  );
};

export default PaymentStatus;
